export const MAXIMUM_BATCH_SIZE = 100;